(function () {
  var galleries = document.querySelectorAll('[data-product-gallery]');
  if (!galleries.length) return;

  function ProductGallery(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-gallery-viewport]');
    this.track = root.querySelector('[data-gallery-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
    this.prev = root.querySelector('[data-gallery-prev]');
    this.next = root.querySelector('[data-gallery-next]');
    this.count = this.slides.length;
    this.index = 0;
    this.touchStartX = null;
    this.touchCurrentX = null;
  }

  ProductGallery.prototype.update = function () {
    var self = this;
    if (!this.track) return;

    this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';

    this.slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === self.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === self.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  };

  ProductGallery.prototype.goTo = function (index) {
    if (this.count <= 1) return;
    if (index < 0) {
      this.index = this.count - 1;
    } else if (index >= this.count) {
      this.index = 0;
    } else {
      this.index = index;
    }

    this.update();
  };

  ProductGallery.prototype.bind = function () {
    var self = this;
    if (this.count <= 1) return;

    if (this.prev) {
      this.prev.addEventListener('click', function () {
        self.goTo(self.index - 1);
      });
    }

    if (this.next) {
      this.next.addEventListener('click', function () {
        self.goTo(self.index + 1);
      });
    }

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(Number(dot.getAttribute('data-gallery-dot')));
      });
    });

    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.goTo(self.index - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.goTo(self.index + 1);
      }
    });

    if (this.viewport) {
      this.viewport.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        self.touchStartX = event.touches[0].clientX;
        self.touchCurrentX = self.touchStartX;
      }, { passive: true });

      this.viewport.addEventListener('touchmove', function (event) {
        if (!event.touches || !event.touches.length) return;
        self.touchCurrentX = event.touches[0].clientX;
      }, { passive: true });

      this.viewport.addEventListener('touchend', function () {
        if (self.touchStartX === null || self.touchCurrentX === null) return;
        var delta = self.touchCurrentX - self.touchStartX;

        if (Math.abs(delta) > 40) {
          if (delta > 0) {
            self.goTo(self.index - 1);
          } else {
            self.goTo(self.index + 1);
          }
        }

        self.touchStartX = null;
        self.touchCurrentX = null;
      });
    }
  };

  galleries.forEach(function (galleryRoot) {
    var gallery = new ProductGallery(galleryRoot);
    gallery.update();
    gallery.bind();
  });
})();
